import React from 'react';
import { Card } from 'react-bootstrap';
import { FaUserLock, FaUserShield, FaGlobeEurope, FaShieldAlt, FaGavel } from 'react-icons/fa';

function NormativeCard({ hyperLink, icon, statusColor, text }) {


    const STAUSCOLOR = {
        'red': "status-red",
        'yellow': "status-yellow",
        'blue': "status-blue",
        'green': "status-green",
        'gray': "status-gray",
        'purple': "status-purple",
    };

    const ICONS = {
        'FaUserLock': FaUserLock,
        'FaUserShield': FaUserShield,
        'FaGlobeEurope': FaGlobeEurope,
        'FaShieldAlt': FaShieldAlt,
        'FaGavel': FaGavel,
    };


    let bgColorClass = STAUSCOLOR[statusColor];
    const IconComponent = ICONS[icon] || null;

    const redirectTo = (url) => {
        window.open(url, '_blank');
    };

    return (
        <div className='mt-4 col-6 rounded-border case-card-container '>
            <Card className='width-90 normative-card-card custom-shadow' onClick={() => redirectTo(hyperLink)} >
                <Card.Body className='normative-card-body'>
                    {IconComponent && <IconComponent className='normative-card-icon' size={40} />}
                    <div className='normative-card-text-container '>
                        <span className='normative-card-text'>{text}</span>
                    </div>
                </Card.Body>
                <div className={`normative-card-color-identifier ${bgColorClass}`}></div>
            </Card>
        </div>
    );
}

export default NormativeCard;